// https://github.com/necolas/react-native-web/issues/1026#issuecomment-687572134

import { AlertButton, AlertStatic } from 'react-native';

const Alert = {
  alert: (title, message, buttons) => {
    if (buttons === undefined || buttons.length === 0) {
      window.alert([title, message].join('\n'));
      return;
    }

    const result = window.confirm([title, message].join('\n'));

    if (result === true) {
      const confirm = buttons.find(({ style }) => style !== 'cancel');
      confirm?.onPress?.();
      return;
    }

    const cancel = buttons.find(({ style }) => style === 'cancel');
    cancel?.onPress?.();
  }
};

export default Alert;
